import { range } from "lodash"
import { bin } from "d3"

export const createHistogram = (data: Float32Array, binEdges: number[]): number[] => {
	const binGenerator = bin()
		.domain([binEdges[0], binEdges[binEdges.length - 1]])
		.thresholds(binEdges)

	return binGenerator(data).map(d => d.length)
}

export const getBinEdges = (minimum: number, binSize: number, maximum: number) => {
	return range(minimum, maximum + binSize / 2, binSize)
}